const zhCN = {
  nav: {
    customerSuccess: '客户成功',
    solutions: '解决方案',
    partnerEcosystem: '合作伙伴生态',
    contactUs: '联系我们',
    login: '登录',
  },
  solutions: {
    smartLaborPerformance: '智能劳动力管理',
    yieldIntelligence: '产量智能',
    harvestManagement: '收获管理',
  },
  home: {
    heroTitle: '探索农业的无限可能',
    heroDesc: '为温室和小农户提供集成的劳动力管理、精准采收和专业种植解决方案。',
    heroCTA: '我们的解决方案',
    impactTitle: 'COSMOS 影响力',
    impactDesc:
      '我们的数字农业解决方案覆盖多个地区，连接农田与加工仓储设施，填补种植管理空白。',
    stats: {
      farmValue: '3,500 公顷',
      farmLabel: '农场作业数字化',
      warehouseValue: '30,000 立方米',
      warehouseLabel: '加工仓储面积数字化',
      countriesValue: '5',
      countriesLabel: '服务国家',
      cropsValue: '20+',
      cropsLabel: '支持作物品类',
      devicesValue: '2000+',
      devicesLabel: '在线智能联网设备',
      ceaValue: '100 公顷',
      ceaLabel: '设施农业管理面积',
      recordsValue: '3000 万+',
      recordsLabel: '采集的运营数据',
      produceValue: '100 万+',
      produceLabel: '吨生鲜农产品数字化追踪',
      leadersValue: '10+',
      leadersLabel: '生鲜行业全球领军者',
      leadersDesc: '全球领先的种植、营销与农产品企业',
      researchValue: '3',
      researchLabel: '产学研创新项目',
      researchDesc: '连接产业与学术',
      jobsValue: '15000+',
      jobsLabel: '带动乡村就业',
      jobsDesc: '为农业社区创造经济机会',
    },
    trustedBy: '信赖伙伴',
    trustedByDesc:
      '我们与全球顶级农业品牌建立长期合作关系，深化产学研创新合作，并通过在全球农业地区创造稳定的就业机会来推动当地乡村经济发展。',
    successTitle: '与我们共同成长',
    cases: {
      Haygrove: 'Haygrove',
      BERRIESBLUE: 'BERRIESBLUE',
      Driscoll: 'Driscoll\'s',
      cherryTag: '区域',
      cherryTitle: '樱桃与蓝莓农场数字化管理',
      packhouseTag: '网络研讨会',
      packhouseTitle: '蓝莓加工厂全链路数字化',
      packhouseDesc:
        '我们与多家知名企业深度合作，使用 COSMOS 将种植、仓储到物流的全流程完整数字化，实现全链路数字化管理。',
      harvestTag: '浆果',
      harvestTitle: '多品类浆果智能采收系统',
      protectedTag: '作物',
      protectedTitle: '蓝莓与樱桃设施栽培项目',
    },
  },
  slp: {
    heroTag: '智能劳动力管理',
    heroTitle: '看见工作，提升成效。',
    heroDesc:
      '实时掌握劳动力作业动态，核验现场执行情况，并自动化工时记录。确保在正确的时间和地点完成正确的工作，同时提升生产效率、责任落实与运营表现。',
    workforceTitle: '劳动力可视化',
    workforceDesc:
      '通过 NFC 打卡、GPS 定位技术与 COSMOS 智能穿戴设备，实时掌握团队所在位置与工作进展。',
    executionTag: 'NFC + GPS / UWB',
    executionTitle: '执行保障',
    executionDesc:
      '核验谁在何时何地完成了哪项工作。NFC、GPS 定位核验与 COSMOS 劳动力穿戴 OS 创建现场执行数字记录，确保关键任务按计划完成。',
    insightsTag: 'AI 助手',
    insightsTitle: '绩效洞察',
    insightsDesc:
      '通过 COSMOS 劳动力绩效门户自动衡量生产率、出勤率、利用率与任务完成度，将劳动力数据转化为运营洞察。',
    testimonial1:
      '作为劳动力管理者，这个工具让我们能够实时监控工作进度和员工状态。自动化管理极大提升了整体运营效率。',
    testimonial2:
      '这套劳动力管理系统大大优化了我们的日常工作。员工排班、采收追踪和考勤管理全部在一个平台上高效完成，真正为团队节省了时间。',
    workflowsTitle: '为农业作业而设计',
    workflowsDesc:
      '通过穿戴设备与数字平台的组合，管理任务分配、工种选择、排班、考勤与绩效，专为农业作业设计。',
    workflow1Desc: '在电脑上排班，一键发布到工人穿戴设备。',
    workflow2Desc: '收到排班信息后，工人选择工种并通过穿戴设备打卡。',
    workflow3Desc: '基于考勤记录与绩效数据自动核算工资并通知。',
  },
  yi: {
    heroTag: '产量智能',
    heroTitle: '预测产量，从容规划。',
    heroDesc:
      '将作物观测、生物模型与 AI 转化为可执行的产量预测，优化采收规划、劳动力调配、包装作业与销售决策。',
    cropScienceTitle: '作物科学与 AI 结合',
    cropScienceDesc:
      '作物生长模型结合真实农场数据，提供可解释、透明、基于作物生物学的预测——而非黑盒算法。',
    forecastsTitle: '将预测转化为行动',
    forecastsDesc:
      '产量预测与运营流程无缝衔接，使团队能够实时规划劳动力、采收计划、包装产能与销售，全部在 COSMOS 产量智能中完成。',
    dataCollectionTitle: '务实的数据采集，为投资回报而设计',
    dataCollectionDesc:
      '预测精度始于正确的数据。COSMOS 设计并部署 AI 驱动的植物数据采集方案——从计算机视觉、移动巡检到传感器与自动化——针对每种作物与生产环境量身定制。',
  },
  hm: {
    heroTag: '收获管理',
    heroTitle: '从枝头到餐桌，让每一颗浆果全程可追溯',
    heroDesc:
      '从露天地块到设施栽培，我们面向不同作物场景提供数字化解决方案——一键采收溯源、运输全程冷链可视、精细到单株的植保管理，以及按需自动化灌溉与施肥。',
    efficiencyTitle: '高效率',
    efficiencyDesc:
      '通过 RFID 批量称重实现高速采收记录与即时工人识别，大幅缩短处理时间。系统兼容多种 RFID 标签与容器形态，灵活适配不同作业流程。',
    traceabilityTitle: '端到端追溯',
    traceabilityDesc:
      '从田间到出货全链路追踪每一批采收数据，田间信息秒级同步到看板，并持续量化劳动力绩效，实现全流程透明可管。',
    traceabilityPoints: [
      '从田间到出货全链路追踪每一批采收数据。',
      '田间信息秒级同步到看板。',
      '持续量化并优化劳动力绩效。',
    ],
    traceabilityImageAlt: '采收追溯看板',
  },
  comingSoon: {
    title: '即将上线',
    desc: '该页面正在建设中，敬请期待！',
    back: '返回首页',
  },
  footer: {
    copyright: '版权所有 © COSMOS',
    contactEmail: 'Shaun.he@cosmos.ag',
    contactVia: '联系方式',
    customerSuccessTitle: '客户成功',
    solutionsTitle: '解决方案',
    partnerTitle: '合作伙伴生态',
    contactTitle: '联系我们',
    partnerHero: 'Hero',
    partnerWhy: '为何与 COSMOS 合作',
    partnerOpportunities: '合作机会',
  },
}

export default zhCN
